<script setup lang="ts">
defineProps<{
  width?: string
}>()
</script>
<template>
  <div :class="[width ? width : 'tw-w-full lg:tw-w-1/2']" v-bind="$attrs">
    <slot />
  </div>
</template>
